module.exports = __webpack_public_path__ + "img/howtop4-100.9b8598c9.jpg";